module.exports = __webpack_public_path__ + "img/play-primary.0c42077.svg";